import { useRouter } from "next/router";
import ReactMarkdown from "react-markdown";

import NextImage from "../elements/image";

import styles from "@/styles/basic-text.module.scss";

const BasicHalfText = ({ data }) => {
  const bg =
    data.backgroundC === "white"
      ? "bg-white"
      : data.backgroundC === "grey"
      ? styles.altBg
      : "bg-onmoBeige";
  const router = useRouter();
  const isCurrentAccount = router.asPath === "/debit-account";

  const Icon = ({ mobile, type }) => {
    if (mobile) {
      if (type === "o") {
        return (
          <div
            className={`absolute z-10 p-5 ${
              isCurrentAccount ? "bottom-0 right-0" : "top-0 left-0"
            }`}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="24" cy="24" r="20" stroke="white" strokeWidth="8" />
            </svg>
          </div>
        );
      }
      return (
        <div className="absolute z-10 bottom-0 right-0 p-5">
          <svg
            width="43"
            height="58"
            viewBox="0 0 43 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="21.7218"
              cy="21.6071"
              r="16.5397"
              stroke="white"
              strokeWidth="8.7051"
            />
            <rect
              x="0.82959"
              y="48.8831"
              width="41.7845"
              height="8.7051"
              fill="white"
            />
          </svg>
        </div>
      );
    } else {
      if (type === "o") {
        return (
          <div
            className={`absolute z-10 p-5 ${
              isCurrentAccount ? "bottom-0 right-0" : "top-0 left-0"
            }`}
          >
            <svg
              width="72"
              height="72"
              viewBox="0 0 72 72"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="36"
                cy="36"
                r="28.5"
                stroke="white"
                strokeWidth="15"
              />
            </svg>
          </div>
        );
      }
      return (
        <div className="absolute z-10 bottom-0 right-0 p-5">
          <svg
            width="72"
            height="98"
            viewBox="0 0 72 98"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="36" cy="36" r="28.5" stroke="white" strokeWidth="15" />
            <rect y="83" width="72" height="15" fill="white" />
          </svg>
        </div>
      );
    }
  };

  return (
    <section className={bg}>
      <div
        className={`grid grid-cols-1 md:grid-cols-11 ${
          isCurrentAccount ? "max-w-1424" : ""
        }  mx-auto min-h-[520px]`}
      >
        <div
          className={`col-span-1 md:col-span-6 p-6 py-16 md:p-24 block md:flex justify-start ${
            isCurrentAccount
              ? `order-first py-16 ${styles.basicCurrentAccountText}`
              : data.imageOrientation === "right"
              ? "order-last md:order-first md:justify-end"
              : "order-last md:order-last"
          }`}
        >
          <ReactMarkdown className={styles.text}>{data.content}</ReactMarkdown>
        </div>
        <div
          className={`w-full relative h-full col-span-1 md:col-span-5 ${
            data.imageOrientation === "right"
              ? styles.imageContainerRight
              : styles.imageContainerLeft
          }`}
        >
          <span className="hidden md:block">
            {data.imageOrientation === "left" ? (
              <Icon mobile={false} />
            ) : (
              <Icon mobile={false} type="o" />
            )}
            <div className="hidden 3xl:block">
              <NextImage media={data.image.data} fixed />
            </div>
            <div className="block 3xl:hidden">
              <NextImage media={data.image.data} full />
            </div>
          </span>
          <span className="block md:hidden">
            {data.imageOrientation === "left" ? (
              <Icon mobile />
            ) : (
              <Icon mobile type="o" />
            )}
            <NextImage media={data.image.data} />
          </span>
        </div>
      </div>
    </section>
  );
};

export default BasicHalfText;
